import React, { useState, useEffect, useRef } from "react";

import "../../css/Banner.css";
import ImgBannerTH from "../../assets/image/Banner-TH.png";

export default function BannerTH(props) {
  return (
    <div className="banner-container">
      <img className="banner" src={ImgBannerTH}></img>
    </div>
  );
}
